import login_logo from "../assets/XDM.svg";
const IMAGES = {
  login_logo: login_logo,
};

export default IMAGES;
